<template>
  <div class="input-wrap" :class="{ 'is-row' :layout && layout === 'row', 'is-large': isLarge }">
    <label v-if="label" :for="id">{{label}}</label>
    <span class="main">
      <input
        type="date"
        :name="id"
        :id="id"
        :disabled="disabled"
        :required="required"
        :readonly="readonly"
        v-model="localValue"
        @change="update"
      />
      <span class="error">
        <slot name="error"></slot>
      </span>
    </span>
  </div>
</template>

<script>
export default {
  name: 'DateInput',
  components: {
  },
  props: {
    id: String,
    type: String,
    value: [String, Date],
    label: String,
    placeholder: String,
    disabled: Boolean,
    layout: String,
    required: Boolean,
    autofocus: Boolean,
    isLarge: Boolean,
    readonly: Boolean,
  },
  data() {
    return {
      localValue: this.value,
    };
  },
  computed: {
    currentDate() {
      return null;
    },
  },
  methods: {
    update() {
      if (this.value !== this.localValue) {
        this.$emit('input', this.localValue);
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '@/styles/input.scss';

.main {
  width: 100%;
}


</style>
